module.exports = {
  "metadata": {
    "width": "20",
    "height": "24",
    "name": "edit"
  },
  "source": "<path d=\"M15.6 22.74H2.39a.89.89 0 0 1-.89-.89V7.29a.89.89 0 0 1 .89-.89h4.67a.89.89 0 1 1 0 1.78H3.28V21h11.43v-6.43a.89.89 0 0 1 1.78 0v7.28a.89.89 0 0 1-.89.89zm3.59-19.13L12 15.24l-.08.1a.88.88 0 0 1-.21.18h-.05l-3.36 1.9a.88.88 0 0 1-1.3-.85l.32-3.68a.86.86 0 0 1 .13-.38v-.07L14.68.82a.89.89 0 0 1 1.23-.29l3 1.86a.89.89 0 0 1 .29 1.22zm-9.73 9l1.49.92 4.57-7.39L14 5.27zm7.75-9.2l-1.49-.92L15 3.76l1.51.89z\"/>"
};